<template>
    <div>
        <h2 class="text-md-center">Extracurriculars</h2>
        <Extracurricular :title="'General trade skills'" :points="tradeSkills"></Extracurricular>
        <Extracurricular :title="'Web Development'" :points="web"></Extracurricular>
        <Extracurricular :title="'INTERAlliance Leadership Council (ILC)'" :points="ILC"></Extracurricular>
    </div>
</template>

<script>
    import Extracurricular from "@/components/Extracurricular";

    export default {
        name: "Extracurriculars",
        components: {
            Extracurricular
        },
        data() {
            return {
                tradeSkills: [
                    'Built my own home',
                    'Carpentry',
                    'Electricity',
                    'HVAC',
                    'Framing',
                    'Insulation',
                    'Auto mechanic'
                ],
                web: [
                    'Coach team of novice developers',
                    'Outline dev paths based on aspirations',
                    'Architect a infra stress free environment with Lambda, S3 static site hosting, Cognito, & API Gateway',
                    'Maintain an agile management style'
                ],
                ILC: [
                    'Progressed into ILC from local chapter',
                    'Assisted in organizing and orchestrating the Tech Olympics',
                    'Leadership and IT skills training',
                    'Advanced into GE summer internships'
                ]
            }
        }
    }
</script>

<style scoped>

</style>
